var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMarketplace(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M27.5 28.4375H2.5C1.9875 28.4375 1.5625 28.0125 1.5625 27.5C1.5625 26.9875 1.9875 26.5625 2.5 26.5625H27.5C28.0125 26.5625 28.4375 26.9875 28.4375 27.5C28.4375 28.0125 28.0125 28.4375 27.5 28.4375Z",
    fill: "#909090"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.125 7.78741C16.95 7.78741 15.775 7.56244 14.65 7.11244C14.3 6.97494 14.0625 6.62493 14.0625 6.23743V2.48743C14.0625 2.17493 14.2125 1.88743 14.475 1.71243C14.7375 1.53743 15.0625 1.49991 15.35 1.61241C17.1375 2.32491 19.1125 2.32491 20.9 1.61241C21.1875 1.49991 21.5125 1.53743 21.775 1.71243C22.0375 1.88743 22.1875 2.17493 22.1875 2.48743V6.23743C22.1875 6.62493 21.95 6.96244 21.6 7.11244C20.475 7.56244 19.3 7.78741 18.125 7.78741ZM15.9375 5.5874C17.3625 6.0249 18.8875 6.0249 20.3125 5.5874V3.77496C18.875 4.12496 17.375 4.12496 15.9375 3.77496V5.5874Z",
    fill: "#909090"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M15 10.9375C14.4875 10.9375 14.0625 10.5125 14.0625 10V6.25C14.0625 5.7375 14.4875 5.3125 15 5.3125C15.5125 5.3125 15.9375 5.7375 15.9375 6.25V10C15.9375 10.5125 15.5125 10.9375 15 10.9375Z",
    fill: "#909090"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M25 28.4375H5C4.4875 28.4375 4.0625 28.0125 4.0625 27.5V13.75C4.0625 10.725 5.725 9.0625 8.75 9.0625H21.25C24.275 9.0625 25.9375 10.725 25.9375 13.75V27.5C25.9375 28.0125 25.5125 28.4375 25 28.4375ZM5.9375 26.5625H24.0625V13.75C24.0625 11.775 23.225 10.9375 21.25 10.9375H8.75C6.775 10.9375 5.9375 11.775 5.9375 13.75V26.5625Z",
    fill: "#909090"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M24.2751 15.9375H5.7251C5.2126 15.9375 4.7876 15.5125 4.7876 15C4.7876 14.4875 5.2126 14.0625 5.7251 14.0625H24.2751C24.7876 14.0625 25.2126 14.4875 25.2126 15C25.2126 15.5125 24.7876 15.9375 24.2751 15.9375Z",
    fill: "#909090"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M10.9253 15H9.05029V27.5H10.9253V15Z",
    fill: "#909090"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M15.9253 15H14.0503V27.5H15.9253V15Z",
    fill: "#909090"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M20.9253 15H19.0503V27.5H20.9253V15Z",
    fill: "#909090"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMarketplace);
export default __webpack_public_path__ + "static/media/marketplace.c47f0f5d11da371430c69b78ab775e23.svg";
export { ForwardRef as ReactComponent };